import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {Helmet} from 'react-helmet';
import { map, sumBy, capitalize } from 'lodash';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import Spinner from '../../components/common/Spinner';
import StatementPeriodDates from '../../components/pages/imports/StatementPeriodDates';
import ReactTable from 'react-table';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import { importsActions } from '../../data/actions/imports';
import CSV from '../../helpers/CSVExport';
import PaidReports from './PaidReports';
import ValidateStatements from './ValidateStatements';
import StatementPeriods from './StatementPeriods';

class PeriodSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			period: null
		}
		this.setPeriod = this.setPeriod.bind(this);
	}
	
	setPeriod(period){
		this.setState({
			period
		});
	}
	
	render() {
		const { period } = this.state;
		return <div className="inner-page shared-pages">
			<div className="container">
				<div className="import-menu import-menu-exceptions">
					<StatementPeriodDates onSelectDate={this.setPeriod} />
				</div>
				{period && <React.Fragment>

					<div className="import-menu import-menu-exceptions">
						<ul>
							{/*<li><Link to={`/import/reports/statement-periods`}>All Periods</Link></li>*/}
							<li><Link to={`/import/reports/paid-reports`}>Paid Reports</Link></li>
							<li><Link to={`/import/reports/validate-statements`}>Validate Statements</Link></li>
						</ul>
					</div>

					<Route path="/import/reports/statement-periods" render={(props)=><StatementPeriods period={period.value} accepted={period.accepted} {...props} />}></Route>
					<Route path="/import/reports/paid-reports" render={(props)=><PaidReports period={period.value} accepted={period.accepted} {...props} />}></Route>
					<Route path="/import/reports/validate-statements" render={(props)=><ValidateStatements period={period.value} accepted={period.accepted} {...props} />}></Route>
				</React.Fragment>}

			</div>
			<Helmet>
				<title>Pending reports</title>
			</Helmet>

		</div>
	}
}

function mapStateToProps(state) {
	return {
		imports: state.imports
	} 
}

export default PeriodSelector;